const SEO = {
  description: "Tarek is an experienced cloud engineer with over 9 years of cloud and software development experience. He specializes in DevOps, security best practices, and implementing cloud solutions.",
  keywords: [
    "Tarek",
    "Mulla",
    "Tarek Mulla",
    "T. Mulla",
    "Tarek M.",
    "Engineer",
    "Consultant",
    "Developer",
    "Project",
    "Cloud",
    "DevOps",
    "Cybersecurity",
    "Security",
    "Programming",
    "CI",
    "CD",
    "IaC",
    "Agile",
    "Mentoring",
    "Database",
    "AWS",
    "Azure",
    "Communication"],
};

export default SEO;
